import { useId, type ReactNode } from "react";

/** A whole-row toggle: label and optional hint on the left, an iOS-style switch on
 * the right. Underneath it is a native checkbox exposed as role="switch". */
export function SwitchRow({
  label,
  hint,
  checked,
  onChange,
  disabled = false,
  icon,
}: {
  icon?: ReactNode;
  label: ReactNode;
  hint?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const id = useId();
  return (
    <label
      className={`ui-switch-row${disabled ? " is-disabled" : ""}${icon ? " has-icon" : ""}`}
    >
      {icon ? (
        <span className="row-icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <span className="switch-text">
        <span className="switch-label">{label}</span>
        {hint ? (
          <span className="ui-hint" id={`${id}-hint`}>
            {hint}
          </span>
        ) : null}
      </span>
      <input
        type="checkbox"
        role="switch"
        className="ui-switch"
        checked={checked}
        disabled={disabled}
        aria-describedby={hint ? `${id}-hint` : undefined}
        onChange={(e) => onChange(e.target.checked)}
      />
    </label>
  );
}
